module.exports = "/_next/static/images/ir-2cd8912993c0f84da988f86b2ca06938.svg";